/* eslint-disable */
import React, { Component } from 'react';
import { Select } from 'antd';
import { apiClient } from '../../../api';
import { root } from '../../../config';
import { token, CheckTokenExp } from '../../../config';
import ModalServerError from '../Modal/ModalServerError';

const { Option } = Select;

export default class SelectAccountMacc extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            list: [],
            select: [],
            modalVisible: false,
        };

        this.getData = this.getData.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.getData("");
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectname !== prevProps.selectname) {
            this.getData(this.props.selectname);
        }
    }

    getData(value) {
        if (!CheckTokenExp()) {
            var search = value.trim() == "" || value == undefined ? "null" : value;
            this.state.list.length > 0 ? "" : this.setState({ loading: true });

            apiClient.get('api/accounts/List/' + search
                , {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then(data => {
                    if (data.status === 200 && data.data) {
                        this.setState({ list: data.data });
                    } else {
                        this.setState({ list: [] });
                        this.setState({ modalVisible: true });
                    }
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({ modalVisible: true });
                    this.setState({ list: [] });
                    this.setState({ loading: false });
                });
        } else {
            window.location.href = "logout";
        }

    }

    onChange(value, e) {
        if (value != undefined) {
            this.props.setStateByProps("accountname", e.props.name);
        }
        this.props.setStateByProps("account", value);
    }

    render() {
        const { loading, list, modalVisible } = this.state;
        const { placeholder, select, setStateByProps, style, mode, showSearch } = this.props;
        return (
            <>
                <Select
                    mode={mode ? mode : "multiple"}

                    showSearch={showSearch ? showSearch : false}
                    allowClear

                    style={style ? style : null}
                    loading={loading}
                    name="select"
                    onSearch={(value) => { this.getData(value) }}
                    onChange={(value, e) => { this.onChange(value, e) }}
                    value={select}
                    suffixIcon={loading ? "" : <span className="fa fa-angle-down" />}
                    placeholder={placeholder ? placeholder : "Account"}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {
                        list.map((item, index) =>
                            <Option key={index} name={item.TEXT} value={item.ID}>{item.TEXT}</Option>
                        )
                    }
                </Select>
                <ModalServerError modalVisible={modalVisible} />
            </>
        );
    }
}


